import React from 'react';

const error = () => <li><span className="badge badge-danger">Could not fetch companies</span></li>;

export default error;